import React, {useState} from "react";
import {Box, CardActions, Grid, Snackbar} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {format} from "date-fns";
import {MUIConfirmationDialog, MUIDatePicker, MUIInput} from "../../utils/formUtils";
import Button from "@material-ui/core/Button";
import axiosInstance from "../../api";
import Spinner from "../../components/Spinner";
import {Alert} from "@material-ui/lab";
import {makeStyles} from "@material-ui/core/styles";
import PropertyAddressViewTile from "../agents/PropertyAddressViewTile";
import PropertyDetailsViewTile from "../agents/PropertyDetailsViewTile";
import OtherDetailsViewTile from "../agents/OtherDetailsViewTile";
import PetsViewTile from "../agents/PetsViewTile";
import LeadContactDetailsViewEditTile from "./LeadContactDetailsViewEditTile";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import add from "date-fns/add/index.js";

const useStyles = makeStyles({
    root: {
        minWidth: 275,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
});

export default function AppDetails({consumerData, setConsumerData, control,errors, hasMultiple, setFetchData, updateData}) {
    const classes = useStyles();
    const [errorMessage, setErrorMessage] = useState(null);
    const [showSpinner, setShowSpinner] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [hasWithdrawn, setHasWithdrawn] = useState(false);
    const [editCoverageDate, setEditCoverageDate] = useState(false);
    const [newCoverageDate, setNewCoverageDate] = useState(new Date());
    const [openSnackBar, setOpenSnackBar] = useState(false);
    const [openSnackBarError, setOpenSnackBarError] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState(null);

    const handleBooleans = (val) => {
        return (!!val) ? "YES" : "NO";
    }

    const saveCoverageInfo = async () => {

        let isValid = (newCoverageDate && newCoverageDate >= new Date() && newCoverageDate <= add(new Date().setMonth(new Date().getMonth()+6),{days:1}))
        if (isValid) {
            setShowSpinner(true);
            setErrorMessage(undefined);
            axiosInstance.post("unauth/leads/changeCoverageDate", {
                userRequestId: consumerData?.userRequestId,
                coverageStartDate: newCoverageDate,
                nonce:consumerData?.nonce,
                createdAt: consumerData?.createdAt
            })
                .then((val) => {
                    setConsumerData(prevState => {
                        let newState = Object.assign({}, prevState);
                        newState["coverageStartDate"] = newCoverageDate;
                        return newState;
                    });
                    updateData({userRequestId:consumerData.userRequestId, coverageDate : newCoverageDate});
                    setSnackBarMessage('Coverage date updated successfully.');
                    setOpenSnackBar(true);
                    setEditCoverageDate(false);
                })
                .catch((err) => {
                    setErrorMessage('An error occurred while updating the Coverage Date. Please try again later or call Citizens at 866.411.2742 for further assistance.');
                    ;
                })
                .finally(() => setShowSpinner(false));


        } else {
            setOpenSnackBarError(true);
        }
    }

    function withDrawUserRequest() {
        setOpenDialog(true);
    }

    function handleDClose() {
        setOpenDialog(false);
    }

    function handleDConfirm() {
        setOpenDialog(false);
        setShowSpinner(true);
        setErrorMessage(undefined);
        axiosInstance.post("unauth/leads/withDrawUserRequest", {
            userRequestId: consumerData?.userRequestId,
            userRequestStatus: "USER_WITHDRAWN",
            nonce:consumerData?.nonce,
            createdAt: consumerData?.createdAt
        })
            .then((val) => {
                setHasWithdrawn(true);
                setErrorMessage(undefined);
                setConsumerData(prevState => {
                    let newState = Object.assign({}, prevState);
                    newState["userRequestStatus"] = 'Withdrawn';
                    return newState;
                });
                updateData({userRequestId:consumerData.userRequestId, userRequestStatus : 'Withdrawn'});
                setSnackBarMessage('Application withdrawn successfully!');
                setOpenSnackBar(true);
            })
            .catch((err) => {
                setErrorMessage('An error occured while the request is withdrawn. Please try again later or call Citizens at 866.411.2742 for further assistance.');
            })
            .finally(() => setShowSpinner(false));
    }



    const handleSnackBarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnackBar(false);
        setOpenSnackBarError(false);
    };


    if (showSpinner) return <Spinner/>

    return (
        <section>
            <Box m={2}>
                <Typography variant="h5" align="left" component="h2" gutterBottom>
                    Property Quote Details
                </Typography>
            </Box>
            <Box m={3}>
                <Card className={classes.root} variant="outlined">
                    <CardContent>
                        <PropertyAddressViewTile consumerData={consumerData} showStatus/>
                    </CardContent>
                </Card>
            </Box>
            <Box m={3}>
                <LeadContactDetailsViewEditTile consumerData={consumerData} hasWithdrawn={hasWithdrawn} errors={errors} control={control} setConsumerData={setConsumerData}/>
            </Box>
            <Box m={3}>
                <Card className={classes.root} variant="outlined">
                    <CardContent>
                        <Typography variant="h5" component="h2">
                            Property Requirement
                        </Typography>
                        <Grid container spacing={2}>
                            {!editCoverageDate && <Grid item xs={12} sm={6} md={4}>
                                When do you need coverage on your property?<br/>
                                <b>{(consumerData?.coverageStartDate) ? format(new Date(consumerData?.coverageStartDate), 'MM/dd/yyyy') : ''}</b>
                            </Grid>}
                            {editCoverageDate && <Grid item xs={12} sm={6} md={4} style={{paddingRight: 18}}>
                                <MUIDatePicker name="coverageStartDate" control={control} errors={errors}
                                               label="When do you need coverage on your property?"
                                               dateValue={newCoverageDate}
                                               handleDateChange={(coverageDate) => setNewCoverageDate(coverageDate)}
                                ></MUIDatePicker>

                            </Grid>}
                            <Grid item xs={12} sm={6} md={4}>
                                What is the value of the property excluding land?<br/>
                                <b>{consumerData?.coverageAmount}</b>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                Why do you need insurance?<br/>
                                <b>{consumerData?.insuranceReason}</b>
                            </Grid>
                            {consumerData?.insuranceReason === 'Shopping Insurance' &&
                            <Grid item xs={12} sm={6} md={4}>
                                What insurance company currently insures your property?<br/>
                                <b>{consumerData?.currentInsurer}</b>
                            </Grid>
                            }
                            {/*<Grid item xs={12} sm={6} md={4}>*/}
                            {/*    Who occupies the home?<br/>*/}
                            {/*    <b>{consumerData?.propertyOccupiedByLabel}</b>*/}
                            {/*</Grid>*/}
                            <Grid item xs={12} sm={6} md={4}>
                                How is the property used?<br/>
                                <b>{consumerData?.propertyUsageLabel}</b>
                            </Grid>
                        </Grid>
                    </CardContent>
                    {hasWithdrawn === false && !['Withdrawn', 'Completed', 'Coverage Found'].includes(consumerData.userRequestStatus) && !editCoverageDate &&
                    <>
                        <CardActions>
                            <Button size="small" color="primary" onClick={() => setEditCoverageDate(true)} variant="outlined">Update Need
                                by Date</Button>
                        </CardActions>
                    </>}
                    {editCoverageDate && <CardActions>
                        <Button size="small" color="primary" onClick={saveCoverageInfo} variant="outlined">Save</Button>
                        <Button size="small" color="secondary"
                                onClick={() => setEditCoverageDate(false)} variant="outlined">Cancel</Button>
                    </CardActions>}
                </Card>
            </Box>
            <Box m={3}>
                <Card className={classes.root} variant="outlined">
                    <CardContent>
                        <PropertyDetailsViewTile consumerData={consumerData}/>
                    </CardContent>

                </Card>
            </Box>
            <Box m={3}>
                <Card className={classes.root} variant="outlined">
                    <CardContent>
                        <OtherDetailsViewTile consumerData={consumerData} handleBooleans={handleBooleans} />
                    </CardContent>
                </Card>
            </Box>
            <Box m={3}>
                <Card className={classes.root} variant="outlined">
                    <CardContent>
                        <PetsViewTile consumerData={consumerData} handleBooleans={handleBooleans} />
                    </CardContent>

                </Card>
            </Box>

            <Grid container alignItems="flex-start" spacing={2}>
                {hasMultiple &&
                <Grid item xs={12} md={4} sm={4}>
                    <Box component="span" justifyContent="flex-start" alignItems="flex-start" display="flex"   style={{marginLeft:18, marginRight:18}}>
                        <Button variant="contained" color="primary" name="btnback"
                                onClick={() => setFetchData(false)}>
                            Back
                        </Button>
                    </Box>
                </Grid>

                }
                <Grid item xs={12}  md={4} sm={4}></Grid>

                <Grid item xs={12} md={4} sm={4}>
                    {hasWithdrawn === false && !['Withdrawn', 'Completed', 'Coverage Found'].includes(consumerData.userRequestStatus) &&
                    <Box component="span" justifyContent="flex-end" alignItems="flex-end" display="flex"  style={{marginLeft:18, marginRight:18}}>
                        <Button type="submit" variant="contained" color="primary" name="btnNext"
                                onClick={withDrawUserRequest}>
                            Withdraw Application
                        </Button>
                    </Box>}
                </Grid>


                <Grid item xs={12}  md={4} sm={4}></Grid>
                <Grid item xs={12}  md={4} sm={4}></Grid>

            </Grid>
            <Snackbar open={openSnackBar} autoHideDuration={6000} onClose={handleSnackBarClose}>
                <Alert variant="filled" onClose={handleSnackBarClose} severity="success">{snackBarMessage}</Alert>
            </Snackbar>

            <Snackbar open={openSnackBarError} autoHideDuration={6000} onClose={handleSnackBarClose}>
                <Alert variant="filled" onClose={handleSnackBarClose} severity="error">Coverage date cannot be past date and should be within next six months.</Alert>
            </Snackbar>

            <Box>
                {errorMessage && <div>
                    <br/>
                    <Alert variant="filled" severity="error">{errorMessage}</Alert>
                </div>}
            </Box>

            <MUIConfirmationDialog dialogTitle="Withdraw Application"
                                   dialogContent="Are you sure you want to withdraw the application?"
                                   showDialog={openDialog} handleDialogClose={handleDClose}
                                   handleUserConfirmation={handleDConfirm}></MUIConfirmationDialog>

        </section>
    );
}
